<template>
  <v-container class="pt-0">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <header-text-bg
          :site="site"
          :text="site.menu_mission_hot_text || 'hotMission'"
        />
      </v-col>
    </v-row>
    <listMissionVertical
      :site="site"
      :dataItems="dataMissionComing"
      typeActivity="active"
    />
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import listMissionVertical from "./listMissionVertical.vue";
import { mapState } from "vuex";
import HeaderTextBg from "./headerTextBg.vue";
export default {
  components: { listMissionVertical, HeaderTextBg },
  data() {
    return {
      dataMissionComing: "",
    };
  },

  mounted() {},

  methods: {
    getMissionComing() {
      Axios.get("mission/listMissionHot")
        .then(({ data }) => {
          this.dataMissionComing = data.data.data;
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            text: err.response.data.message,
            showConfirmButton: false,
            timer: 2000,
          });
        });
    },
  },
  created() {
    this.getMissionComing();
  },
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
  },
};
</script>

<style lang="scss" scoped></style>
